// extracted by css-extract-rspack-plugin
export default {"multiselect":"multiselect-WkGr6v"};